module.exports = __webpack_public_path__ + "img/guanzhuangwuliao-hou.14ec6d21.jpg";